import { cn } from '@/utils/tailwind-util';
import { XIcon } from '@heroicons/react/solid/index';
import React from 'react';

import { IconButton } from '@/components/Button';

export interface ModalLayerProps {
  onClose: () => void;
  children: (props: Pick<ModalLayerProps, 'onClose'>) => React.ReactNode;
  zIndex: number;
  size?: 'auto' | 'md' | 'lg' | 'xl';
  hasCloseButton?: boolean;
  hasDefaultPadding?: boolean;
}

const _ModalLayer = React.forwardRef<HTMLDivElement, ModalLayerProps>(
  (
    { size, zIndex, hasCloseButton, hasDefaultPadding, onClose, children },
    ref
  ) => {
    return (
      <div
        style={{
          zIndex,
        }}
        className={cn(
          'relative inline-block my-8 overflow-visible text-left align-middle transition-all transform bg-white shadow-xl rounded-2xl',
          hasDefaultPadding ? 'p-8' : 'p-0',
          size === 'auto' && 'w-auto min-w-80',
          size === 'md' && 'w-full max-w-md',
          size === 'lg' && 'w-full max-w-lg',
          size === 'xl' && 'w-full max-w-xl'
        )}
        ref={ref}
      >
        {children({ onClose })}
        {hasCloseButton && (
          <div className="inline-block absolute top-[1.625rem] right-6">
            <IconButton
              size="md"
              label="close"
              iconElement={<XIcon />}
              onClick={onClose}
            />
          </div>
        )}
      </div>
    );
  }
);

_ModalLayer.displayName = '_ModalLayer';

_ModalLayer.defaultProps = {
  size: 'md',
  hasCloseButton: false,
  hasDefaultPadding: true,
};

export default _ModalLayer;
